module.exports = __webpack_public_path__ + "img/no-photo.cfe3bcae.svg";